// extracted by mini-css-extract-plugin
module.exports = {"showTopSeparator":"Footer_showTopSeparator_1GMhQ","privacy":"Footer_privacy_7SorC"};